/**
 * /policies/government-layer — Mutaba'aa Government Interaction
 * Layer (Pack 10 v2). The dissolved v0 SocialInsuranceAgent's
 * workflows now live here under Mutaba'aa.
 */

import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

const PROVIDERS = [
  { id: "mudad", label: "Mudad / WPS", desc: ">85% match rule on payroll submission" },
  { id: "gosi", label: "GOSI", desc: "30d registration SLA + 7d exit filing + contribution" },
  { id: "cchi", label: "CCHI", desc: "Mandatory health insurance with dependent coverage" },
  { id: "qiwa", label: "Qiwa", desc: "Contract registration + termination filings" },
  { id: "muqeem", label: "Muqeem", desc: "Iqama renewal + dependent updates" },
  { id: "zatca", label: "ZATCA", desc: "Zakat for Saudi-owned LEs + VAT on contractors" },
];

export function GovernmentLayerPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Government Interaction Layer (Mutaba'aa)"
        subtitle="Pack 10 v0 dissolved — SocialInsuranceAgent's workflows fold into Mutaba'aa. Six external providers."
      />

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">External providers Mutaba'aa coordinates with</h3>
        </div>
        <div className="space-y-2">
          {PROVIDERS.map((p) => (
            <div key={p.id} className="p-3 border border-border-subtle rounded">
              <div className="font-medium text-sm">{p.label}</div>
              <div className="text-xs text-text-secondary mt-1">{p.desc}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
